const URL = {
    EMBED: 'html-embed-generator/generate',
  }
  
  export default URL
  